import { Popover, styled } from "@mui/material";

export const LiPopover = styled(Popover)(({ sx }) => ({
    "& > div ": { boxShadow: `rgba(0, 0, 0, 0.24) 0px 3px 5px !important;` },
    ...(sx as Record<string, string>),
}));
